module.exports = __webpack_public_path__ + "static/img/14-1.099fe36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/14-1.jpg
// module id = Xl6i
// module chunks = 0